import constants from '@/Constants';
import { getSubdomain } from '@/utils/getSubdomain';
import axios from 'axios';

import {
  ExportResponse,
  PollExportStatusParams,
  ScorePayload,
} from './interfaces';

export { getScoreColor } from '@/utils/scoreColor';

export const getScore = (params: Partial<ScorePayload>) => {
  const { scoreObtained, totalScore } = params;
  if (totalScore) {
    const obtained = scoreObtained || 0;

    return (obtained / totalScore) * 100;
  }
  return 0;
};

// Note: These labels should be translated in the component that uses them
export const QUESTION_FILTERS = [
  {
    key: 'all',
    labelKey: 'common.all',
  },
  {
    key: 'image',
    labelKey: 'common.images',
  },
  {
    key: 'flagged',
    labelKey: 'common.non_compliant',
  },
  {
    key: 'feedbacks',
    labelKey: 'common.feedbacks',
  },
];

export async function pollingExportStatus(
  params: PollExportStatusParams,
): Promise<ExportResponse> {
  const { token, interval = 2000, toast } = params;
  const allowedStatuses = ['pending', 'processing'];

  const checkStatus = async (): Promise<ExportResponse> => {
    try {
      const subdomainFromHost = getSubdomain();
      const url = constants.REPORTS_API_URL || '';
      const parsedUrl = url
        .toLowerCase()
        .replace('{{workspace}}', subdomainFromHost);

      const response = await axios.get(
        `${parsedUrl}external_export?token=${token}`,
        {
          headers: {
            Authorization: constants.REPORTS_API_AUTHORIZATION_TOKEN,
          },
        },
      );
      const data = response.data as ExportResponse;

      if (data.status === 'done' && data.downloadFileUrl) {
        window.open(data.downloadFileUrl, '_blank');

        toast?.({
          title: 'Download concluído!',
          description: 'O arquivo está sendo baixado.',
          status: 'success',
          duration: 5000,
          isClosable: true,
        });
        return data;
      }

      if (data.status === 'failure') {
        toast?.({
          title: 'Erro no processamento',
          description: 'Não foi possível gerar o arquivo. Tente novamente.',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        throw new Error('Falha no processamento do export');
      }

      if (allowedStatuses.includes(data.status)) {
        await new Promise((resolve) => setTimeout(resolve, interval));
        return checkStatus();
      }

      toast?.({
        title: 'Status inesperado',
        description: `O servidor retornou um status inesperado: ${data.status}`,
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      throw new Error(`Status inesperado: ${data.status}`);
    } catch (err) {
      toast?.({
        title: 'Erro na comunicação',
        description: 'Não foi possível verificar o status do export.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      throw err;
    }
  };

  return checkStatus();
}
